<template>
  <div v-if="post">
    <div class="c-flex as jc s w100 c-com">
      <div v-if="!leTbS" class="c-img c-cover-80">
        <c-img v-if="post.content.icid == -1" :src="`/cover/c/${post.options.cid}/${post.options.cc_at}/`" />
        <c-img v-else :src="`/cover/invite/c/${post.content.icid}/${post.options.cc_at}/`" />
      </div>
      <div class="c-explain">
        <div class="c-name" :style="maxNameWidth">{{ post.options ? post.options.name : 'UNKNOWN' }}</div>
        <div v-if="leTbS" class="c-img c-cover-120">
          <c-img v-if="post.content.icid == -1" :src="`/cover/c/${post.options.cid}/${post.options.cc_at}/`" />
          <c-img v-else :src="`/cover/invite/c/${post.content.icid}/${post.options.cc_at}/`" />
        </div>
        <template v-if="post.options.explain">
          <v-btn class="c-show-btn" flat color="clr-btn" @click="showExplain = !showExplain">
            <span v-if="!showExplain">{{ $T('common.show_detail') }}</span
            ><span v-if="showExplain">{{ $T('common.hide_detail') }}</span>
          </v-btn>
          <transition name="top">
            <div v-show="showExplain" class="c-msg c-wiki" v-html="fmtExplain(post.options.explain)"></div>
          </transition>
        </template>
        <div class="c-condition" v-if="condition">
          <span class="c-ttl">{{ $T('attributes.rule_subscription') }}</span>
          <span class="c-cond-content">
            <template v-if="getGenderCondition">
              <span class="c-attr">{{ $T('attributes.rule_gender') }} : </span
              ><span class="c-val">{{ getGenderCondition }}</span>
            </template>
            <template v-if="getAgeCondition">
              <span class="c-attr">{{ $T('attributes.rule_age') }} : </span
              ><span class="c-val">{{ getAgeCondition }}</span>
            </template>
          </span>
        </div>
      </div>
    </div>
    <div v-if="completeSuccessfuly" class="c-comp-msg">
      <div>
        <span class="c-msg c-complete-text">{{ $T('post.invited.completed') }}</span>
      </div>
      <div v-if="post.result.r">
        <span class="c-result clr-primary--text">{{ $T('button.accept') }}</span>
      </div>
      <div v-else>
        <span class="c-result clr-danger--text">{{ $T('button.decline') }}</span>
      </div>
    </div>
    <div v-else-if="hasErr">
      <div class="c-msg">{{ $T('post.invited.err_msg') }}</div>
      <div class="c-err-msg f-danger">{{ errMsg }}</div>
      <div class="c-post-btn-space"></div>
      <post-button
        ref="btn"
        :initPost="post"
        :title="isAnswered ? $T('post.btn.confirmed') : isExpired ? $T('common.expired') : $T('post.btn.confirm')"
        :disabled="isGuest || isCompleted"
        @click="onCheckClicked"
      />
    </div>
    <div v-else>
      <div class="c-msg c-comp">{{ $T('post.invited.msg') }}</div>
      <div class="c-prof">
        <select-cover
          type="profile"
          :cid="this.post.community_id"
          ref="cover"
          :coverPath="this.post.options.invited_cover_path"
        />
        <div class="c-prof-name">
          <v-text-field
            data-vv-name="profile"
            data-vv-validate-on="blur"
            ref="input_profile"
            :label="$T('attributes.profile')"
            v-model="profileName"
            color="clr-primary"
            counter="50"
            v-validate="'required|max:50'"
            :error-messages="getMessage('profile')"
            required
            autofocus
            :disabled="loading || !isActive"
          ></v-text-field>
        </div>
      </div>
      <div class="c-flex jc c w100 c-action">
        <v-btn
          color="clr-secondary"
          outline
          @click.native="onApproveClicked"
          :loading="accept && loading"
          :disabled="!isActive || loading"
          >{{ $T('button.accept') }}</v-btn
        >
        <v-btn
          color="clr-danger"
          outline
          @click.native="onRejectClicked"
          :loading="!accept && loading"
          :disabled="!isActive || loading"
          >{{ $T('button.decline') }}</v-btn
        >
      </div>
    </div>

    <msg-dialog ref="msg_dialog" />
  </div>
</template>

<script>
import postDetailPlugin from '../../utils/plugin/postDetailPlugin';
import { mapActions } from 'vuex';
import UTILS from '../../utils/utils';
import {
  getPostForInvite,
  answerInvitationAccept,
  answerInvitationDecline,
  answerInvitationChecked,
} from '../../api/post';
import selectCover from '../common/SelectCover.vue';

export default {
  mixins: [postDetailPlugin],
  components: {
    'select-cover': selectCover,
  },
  props: {
    initPost: { type: Object, required: true },
  },
  data: function() {
    return {
      post: null,
      c: null,
      loading: false,
      accept: false,
      profileName: null,
      condition: null,
      apiErrors: {},
      showExplain: false,
    };
  },
  mounted() {
    this.setup(this.initPost);
  },
  watch: {
    initPost(n, o) {
      this.setup(n);
    },
  },
  computed: {
    acceptable() {
      return this.completed_atthis.options;
    },
    completeSuccessfuly() {
      return !this.post.result.e && !!this.post.completed_at;
    },
    errType() {
      return this.post.result.e || (this.isPast(this.post.expire_at) ? 3 : 0) || this.post.options.inviteErr || 0;
    },
    hasErr() {
      return !!this.errType && this.errType != 4;
    },
    errMsg() {
      switch (this.errType) {
        case 1:
          return $T('post.invited.err.invite_code');
        case 2:
          return $T('post.invited.err.invite_disabled');
        case 3:
          return $T('post.invited.err.expired');
        case 4:
          return $T('post.invited.err.used');
        case 5:
          return $T('post.invited.err.already_member');
        case 6:
          return $T('post.invited.err.waiting');
        case 7:
          return $T('page.member.invite.err.no_condition.msg');
        case 10:
          return $T('page.member.invite.err.member_limit.msg');
        case 99:
          return $T('post.invited.err.banned');
        case 100:
          return $T('post.invited.err.community_dissolved');
      }
      return $T('error_mess.server_error');
    },
    maxNameWidth() {
      var w = 300;
      if (this.geMax) w = 562;
      else if (this.gePc) w = this.w - 550 - 207;
      else if (this.leSp) w = this.w - 102;
      else if (this.leTbS) w = this.w - 177;
      else if (this.leTb) w = this.w - 250 - 207;
      return `max-width: ${w}px;`;
    },
    getGenderCondition() {
      if (!this.condition) return false;
      switch (this.condition.gender) {
        case 0:
          return false;
        case 1:
          return $T('params.gender.male');
        case 2:
          return $T('params.gender.female');
        case 3:
          return $T('params.gender.other');
      }
      console.error('Unknown gender condition ' + this.errType);
      return 'Unknown Gender Condition';
    },
    getAgeCondition() {
      if (!this.condition || (!this.condition.min_age && !this.condition.max_age)) return false;
      let min = this.condition.min_age ? this.condition.min_age : '';
      let max = this.condition.max_age ? this.condition.max_age : '';
      return $T('common.min_max.range', { min: min, max: max });
    },
    isActive() {
      return !this.$utils.isPostCompleted(this.post);
    },
  },
  methods: {
    ...mapActions({
      refreshPostById: 'refreshPostById',
      refreshCommunity: 'refreshCommunity',
    }),
    setup(post) {
      this.loading = false;
      this.accept = false;
      this.profileName = null;
      this.condition = null;
      this.apiErrors = {};
      var self = this;
      getPostForInvite(post.id)
        .then(function(post) {
          self.post = post;
          self.profileName = post.options.invited_name;
          self.condition = post.options.condition;
        })
        .catch(function(e) {
          console.error('failed to get posts data', e);
          self.errGetData();
        });
    },
    fmtExplain(v) {
      return markdown(v);
    },
    getMessage(fieldName) {
      return this.apiErrors[fieldName] && this.apiErrors[fieldName][this.inputValue]
        ? this.apiErrors[fieldName][this.inputValue]
        : this.errors.collect(fieldName);
    },
    onApproveClicked() {
      if (this.isGuest) return;

      this.accept = true;
      var data = new FormData();
      data.append('profile_name', this.profileName);
      data.append('profile_cover', this.$refs.cover.path);
      this.$refs.cover.appendDeletedCoversToForm(data, 'profile_deleted');
      this.$refs.cover.appendNewCoversToForm(data, 'profile_files');
      this.loading = true;
      var self = this;
      this.$validator.validateAll().then(result => {
        if (result) {
          self._callApi(answerInvitationAccept, data);
        } else {
          self.loading = false;
          if (error.option && error.option.type == 'COMPLETED') {
            self.post.is_complete = true;
            self.post.completed_at = error.option.t;
            self.post.result = error.option.r;
            self.$emit('modified', self.post);
          }
          console.error('failed to answer post data for pid[' + self.post.id + ']', error);
        }
      });
    },
    onRejectClicked() {
      if (this.isGuest) return;

      this.accept = false;
      this._callApi(answerInvitationDecline, null);
    },
    onCheckClicked() {
      if (this.isGuest) return;

      var data = new FormData();
      data.append('errType', this.errType);
      this._callApi(answerInvitationChecked, data);
    },
    async _callApi(method, data) {
      this.loading = true;
      try {
        const post = await method(this.post.id, data);
        this.loading = false;
        this.post = post;
        this.profileName = post.options.invited_name;
        this.condition = post.options.condition;
        this.$emit('modified', post);
      } catch (error) {
        this.loading = false;
        if (error.type == 'MemberCountExceed') {
          this.post.options.inviteErr = 10;
        } else if (error.option && error.option.type == 'COMPLETED') {
          this.post.is_complete = true;
          this.post.completed_at = error.option.t;
          this.post.result = error.option.r;
          this.$emit('modified', this.post);
        }
        console.error('failed to answer post data for pid[' + this.post.id + ']', error);
      }
    },
    onMsgClosed() {
      this.$router.push({ name: 'topHome', params: { id: this.selectedCommunity.id } });
    },
  },
};
</script>

<style scoped>
.c-action {
  margin: 10px 0px 10px 0px;
}
.le-tbs .c-action {
  margin: 0 0px 10px 0px;
}
.c-confirm-btn {
  min-width: 200px;
}
.c-img {
  margin-top: 11px;
}
.le-tbs .c-img {
  margin: 0 auto;
}
.c-img img {
  margin: 0 auto;
}
.c-explain {
  flex-grow: 1;
  padding-left: 24px;
  align-self: center;
}
.le-sp .c-explain {
  padding-left: 0px;
}
.c-name {
  text-align: left;
  font-size: 20px;
  font-weight: 600;
  padding: 8px 0 !important;
  color: rgba(0, 0, 0, 0.87);
}
.c-role {
  text-align: left;
  font-size: 16px;
  padding-bottom: 10px;
}
.c-role.f-danger {
  color: #e64a19 !important;
}
.c-explain .c-msg {
  white-space: initial;
  size: 12px;
  color: rgba(0, 0, 0, 0.72);
  padding: 8px 0;
}
.c-err-msg {
  margin: 10px 0px 5px 0px;
  font-size: 18px;
}
.c-com {
  margin: 10px 0px 20px 0px;
}
.le-tbs .c-com {
  margin: 10px 0px;
}
.c-tm {
  font-size: 14px;
}
.c-tm .v-icon {
  font-size: 19px !important;
}
.c-tm.e {
  margin-bottom: 3px;
}
.c-tm.b {
  color: #e64a19;
}
.c-comp {
  margin: 25px 0 30px 0;
}
.le-tbs .c-comp {
  margin: 10px 0 20px 0;
}
.c-comp-msg {
  font-size: 18px;
  padding-top: 15px;
}
.c-prof {
  margin: 20px auto 25px auto;
  width: 75%;
}
.c-prof-name {
  margin-top: 24px;
}
.c-condition {
  padding: 8px 0;
}
.c-condition .c-ttl {
  color: rgba(0, 0, 0, 0.72);
  font-size: 16px;
  font-weight: 600;
}
.c-condition .c-cond-content {
  text-align: left;
}
.c-condition .c-attr {
  margin-left: 10px;
  color: rgba(0, 0, 0, 0.72);
  font-size: 12px;
}
.c-condition .c-val {
  font-size: 16px;
  font-weight: 600;
}
.c-complete-text {
  font-size: 14px;
}
.c-result {
}
</style>
